import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { DataDictionaryApi } from '../../../api/data-dictionary-api';
import { LayerApi } from '../../../api/layer-api';
import { util } from '../../../classes/util';
import { BooleanConverter, InputConverter, NumberConverter } from '../../../inputConverter';
import { keys } from '../../../keys';
import { ExportService } from '../../../services/export.service';
import { LayerService } from '../../../services/layer.service';
import { StorageService } from '../../../services/storage.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';
import { RowClass } from '../../utilityComponents/table/table-types';
/* tslint:disable:template-cyclomatic-complexity */
var DataTableComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DataTableComponent, _super);
    /* tslint:disable:max-file-line-count */
    function DataTableComponent(_vcr, changeDetectorRef, exportService, layerService, dataDictionaryApi, toSqlStringService, layerApi, LoggingService, userSettingsService, authService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.exportService = exportService;
        _this.layerService = layerService;
        _this.dataDictionaryApi = dataDictionaryApi;
        _this.toSqlStringService = toSqlStringService;
        _this.layerApi = layerApi;
        _this.LoggingService = LoggingService;
        _this.userSettingsService = userSettingsService;
        _this.authService = authService;
        _this._columnSettings = [];
        _this._columnSortOrder = 'database';
        _this._opened = false;
        _this._mapcoreProps = [];
        _this.columnSettingsDialogOpened = null;
        _this.dataFetched = [];
        _this.delayForFetchingNewColumnData = 800;
        _this.layerColumns = [];
        _this.pageSize = 100;
        _this.recordEditorEnabled = false;
        _this.maxDefaultColumns = 10; // When insufficient columnSettings are supplied. We fill up the tableColumnSettings to this number.
        _this.maxRecordsFetched = 10000000;
        _this.defaultRecordsFetched = 5000;
        _this.enableAdditionalInformation = false;
        _this.closeTab = new EventEmitter();
        _this.ondrawcomplete = new EventEmitter();
        _this.ondraw = new EventEmitter();
        _this.openEditor = new EventEmitter();
        _this.geoSnapTableId = 161;
        _this.aggregates = [];
        _this.childTableData = [];
        _this.tableColumnSettings = [];
        _this.columnSettingsFilterText = '';
        _this.columnSettingsSortField = 'order';
        _this.columnSettingsSortDescending = false;
        _this.gridDataResult = null;
        _this.filteredData = [];
        _this.filterSettings = [];
        _this.fullData = [];
        _this.idPropertyName = 'objectid';
        _this.showFooter = false;
        _this.rowCount = '';
        _this.selectedObjectIds = [];
        _this.showSelected = false;
        _this.sortSettings = [];
        _this.updateStorage = true;
        _this.layerChildTables = null;
        _this.childTableChildParentKeyColumnNames = null;
        _this.featureChildTables = null;
        _this.tableIdToTableDictionary = {};
        _this.showCloseOptions = false;
        _this.hideCustomSort = true;
        _this.enableMultiTabs = false;
        _this.multiTabsArr = [];
        _this.maxRecordFetchList = [
            { name: '100', value: 100 },
            { name: '500', value: 500 },
            { name: '1,000', value: 1000 },
            { name: '5,000', value: 5000 },
            { name: '10,000', value: 10000 },
            { name: '50,000', value: 50000 },
            { name: '100,000', value: 100000 }
        ];
        _this.mapcorePropsIndex = 0;
        _this.availableCababilities = [];
        _this.userPermissions = [];
        _this.titleProperty = 'name';
        _this.columnSettingsFilteredForDialog = [];
        _this.allVisible = false;
        _this.allSum = false;
        _this.allAverage = false;
        _this.accessingLocalStorage = Promise.resolve();
        _this.refreshGrid = function () {
            _this.refreshGridData();
        };
        _this.close = function (esriLayerId) {
            if (esriLayerId) {
                var closeIndex = _this._mapcoreProps.findIndex(function (p) { return p.esriLayerId === esriLayerId; });
                if (closeIndex > -1) {
                    _this.closeTab.emit(esriLayerId);
                    _this._mapcoreProps.splice(closeIndex, 1);
                    if (closeIndex === _this.mapcorePropsIndex && _this.mapcorePropsIndex >= _this._mapcoreProps.length) {
                        _this.mapcorePropsIndex = _this._mapcoreProps.length - 1;
                    }
                    if (_this._mapcoreProps.length < 2) {
                        _this.enableMultiTabs = false;
                        _this.multiTabsArr = [];
                        _this.curMultiTab = '';
                    }
                    if (!_this._mapcoreProps.length) {
                        _this.opened = false;
                        _this.dataFetched = [];
                        _this.selectedObjectIds = [];
                        _this.layerChildTables = [];
                        _this.hideCustomSort = true;
                        _this.lassoTool.destroy();
                    }
                }
            }
            else if (_this._mapcoreProps.length > 1) {
                if (_this._mapcoreProps.length === 2) {
                    _this.enableMultiTabs = false;
                    _this.multiTabsArr = [];
                    _this.curMultiTab = '';
                }
                _this.closeTab.emit(_this.mapcoreProps.esriLayerId);
                _this._mapcoreProps.splice(_this.mapcorePropsIndex, 1);
                _this.mapcorePropsIndex = 0;
            }
            else {
                _this.closeTab.emit(_this.mapcoreProps.esriLayerId);
                _this.mapcoreProps.dataTableArr = [];
                _this._mapcoreProps = [];
                _this.opened = false;
                _this.dataFetched = [];
                _this.selectedObjectIds = [];
                _this.layerChildTables = [];
                _this.hideCustomSort = true;
                _this.lassoTool.destroy();
            }
            _this.showCloseOptions = false;
        };
        _this.closeAll = function () {
            if (_this._mapcoreProps) {
                while (_this._mapcoreProps.length > 0) {
                    _this.close();
                }
            }
        };
        _this.columnSortByDBOrder = function (a, b) {
            if (a.databaseColumnOrder > b.databaseColumnOrder) {
                return 1;
            }
            else if (a.databaseColumnOrder > b.databaseColumnOrder) {
                return -1;
            }
            return 0;
        };
        _this.expandDetailsBy = function (dataItem) {
            return dataItem.objectid;
        };
        _this.sortColumns = function (columns) {
            if (columns && columns.length > 0) {
                var columnDatabaseOrder_1 = 'databaseColumnOrder' in columns[0] ? 'databaseColumnOrder' : 'columnOrder';
                var columnDisplayName_1 = 'displayName' in columns[0] ? 'displayName' : 'title';
                var columnPropertyName_1 = 'name' in columns[0] ? 'name' : 'propertyName';
                var alphaSort = function (a, b) {
                    var aComp = a[columnDisplayName_1].toUpperCase();
                    var bComp = b[columnDisplayName_1].toUpperCase();
                    if (aComp.localeCompare(bComp) > 1) {
                        return 1;
                    }
                    else if (aComp.localeCompare(bComp) < 1) {
                        return -1;
                    }
                    return 0;
                };
                var dbSort = function (a, b) {
                    if (a[columnDatabaseOrder_1] > b[columnDatabaseOrder_1]) {
                        return 1;
                    }
                    else if (a[columnDatabaseOrder_1] < b[columnDatabaseOrder_1]) {
                        return -1;
                    }
                    return 0;
                };
                var findColumnIndex_1 = function (cs) {
                    return _this.columnSettings.findIndex(function (c) { return c.name.toUpperCase() === cs[columnPropertyName_1].toUpperCase(); });
                };
                var customSort = function (a, b) {
                    var aIndex = findColumnIndex_1(a);
                    var bIndex = findColumnIndex_1(b);
                    if (aIndex > bIndex) {
                        return 1;
                    }
                    else if (aIndex < bIndex) {
                        return -1;
                    }
                    return 0;
                };
                switch (_this.columnSortOrder) {
                    case 'alphabetical':
                        columns.sort(alphaSort);
                        break;
                    case 'custom':
                        columns.sort(customSort);
                        break;
                    case 'database':
                        columns.sort(dbSort);
                        break;
                    default:
                        break;
                }
            }
            return columns;
        };
        _this.registerEvent('closeTab', _this.closeTab);
        _this.localStorageService = new StorageService({ userSettingsService: userSettingsService, authService: authService });
        _this.authService.permissions.subscribe(function (permissions) { return _this.userPermissions = permissions || []; });
        return _this;
    }
    Object.defineProperty(DataTableComponent.prototype, "visibleGridColumns", {
        get: function () {
            return this.tableColumnSettings ? this.tableColumnSettings.filter(function (c) { return c.isVisible; }) : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "rowCountNumber", {
        get: function () {
            return !!this.rowCount ? parseInt(this.rowCount.replace(/,/g, ''), 10) : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "canDelete", {
        get: function () { return this.availableCababilities.includes('DR'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "canInsert", {
        get: function () { return this.availableCababilities.includes('IR'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "canUpdate", {
        get: function () { return this.availableCababilities.includes('UR'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "columnSortOrder", {
        get: function () { return this._columnSortOrder; },
        set: function (val) {
            var _this = this;
            if (val !== this._columnSortOrder) {
                this._columnSortOrder = val;
                (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var hasKey;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.accessingLocalStorage];
                            case 1:
                                _a.sent();
                                if (!this.updateStorage) return [3 /*break*/, 6];
                                return [4 /*yield*/, this.localStorageService.hasKey(this.columnSettingsStorageKey)];
                            case 2:
                                hasKey = _a.sent();
                                if (!hasKey) return [3 /*break*/, 4];
                                return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'sortBy', this._columnSortOrder, 'data-table')];
                            case 3:
                                _a.sent();
                                return [3 /*break*/, 6];
                            case 4: return [4 /*yield*/, this.createOrUpdateFromLocalStorage('order')];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6:
                                this.setColumnSettingsFilteredForDialog();
                                return [2 /*return*/];
                        }
                    });
                }); })();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "columnSettings", {
        get: function () { return this._columnSettings; },
        set: function (val) {
            var _this = this;
            if (val !== this._columnSettings) {
                this._columnSettings = val;
                (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var hasKey;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.accessingLocalStorage];
                            case 1:
                                _a.sent();
                                if (!this.updateStorage) return [3 /*break*/, 6];
                                return [4 /*yield*/, this.localStorageService.hasKey(this.columnSettingsStorageKey)];
                            case 2:
                                hasKey = _a.sent();
                                if (!hasKey) return [3 /*break*/, 4];
                                return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'columnSettings', this.mapColumnsForSave(this._columnSettings), 'data-table')];
                            case 3:
                                _a.sent();
                                return [3 /*break*/, 6];
                            case 4: return [4 /*yield*/, this.createOrUpdateFromLocalStorage('columnSettings')];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6:
                                this.setColumnCheckboxes();
                                this.setColumnSettingsFilteredForDialog();
                                return [2 /*return*/];
                        }
                    });
                }); })();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "opened", {
        get: function () { return this._opened; },
        set: function (val) {
            this._opened = val;
            if (this._opened) {
                if (this.mapcoreProps && this.mapcoreProps.dataTableArr && this.mapcoreProps.dataTableArr[this.mapcorePropsIndex] && !this.mapcoreProps.dataTableArr[this.mapcorePropsIndex].maxFetchRecord) {
                    this.mapcoreProps.dataTableArr[this.mapcorePropsIndex].maxFetchRecord = this.defaultRecordsFetched;
                }
                window.addEventListener('itemInserted', this.storageUpdated.bind(this));
            }
            else {
                window.removeEventListener('itemInserted', this.storageUpdated.bind(this));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "mapcoreProps", {
        get: function () {
            return this._mapcoreProps[this.mapcorePropsIndex];
        },
        set: function (mapcoreProps) {
            var _this = this;
            var newEsriLayerId = mapcoreProps.esriLayerId;
            this.gridDataResult = null;
            this.tableColumnSettings = [];
            this.showSelected = false;
            this._columnSortOrder = 'database';
            this.changeDetectorRef.detectChanges();
            //find if the layer has already been added
            var i = this._mapcoreProps.findIndex(function (x) { return newEsriLayerId === x.esriLayerId; });
            if (i > -1) {
                //already exist
                this.mapcorePropsIndex = i;
            }
            else {
                //create new entry
                this._mapcoreProps.push(mapcoreProps);
                this.mapcorePropsIndex = this._mapcoreProps.length - 1;
            }
            if (this._mapcoreProps[this.mapcorePropsIndex].dataTableArr && this._mapcoreProps.length > 1) {
                this.enableMultiTabs = true;
                this.multiTabsArr = this._mapcoreProps[this.mapcorePropsIndex].dataTableArr;
                this.curMultiTab = newEsriLayerId;
            }
            else {
                this.enableMultiTabs = false;
                this.multiTabsArr = [];
                this.curMultiTab = '';
            }
            if (this.mapcoreProps.state === undefined) {
                this.mapcoreProps.state = {};
            }
            if (!mapcoreProps.isExternal && mapcoreProps.permissions && this.userPermissions && this.userPermissions.length) {
                this.availableCababilities = mapcoreProps.permissions.filter(function (per) { return _this.userPermissions.includes(per.name); }).map(function (per) { return per.action; });
            }
            this.refreshGridData().then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.createOrUpdateFromLocalStorage()];
                        case 1:
                            _a.sent();
                            this.changeDetectorRef.detectChanges();
                            return [2 /*return*/];
                    }
                });
            }); });
        },
        enumerable: true,
        configurable: true
    });
    DataTableComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _a.mapView = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.storageUpdated = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((!e.detail.caller || e.detail.caller !== 'data-table') && e.detail.key.startsWith(keys.storage.columnSettingsStorage.slice(0, keys.storage.columnSettingsStorage.indexOf('{') - 1)))) return [3 /*break*/, 5];
                        if (!!this.updateStorage) return [3 /*break*/, 2];
                        return [4 /*yield*/, util.retryUntilValue(function () { return _this.updateStorage ? true : undefined; }, 2000, 100)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.updateStorage) return [3 /*break*/, 5];
                        this.updateStorage = false;
                        return [4 /*yield*/, this.createOrUpdateFromLocalStorage()];
                    case 3:
                        _a.sent();
                        this.refreshColumnSettings();
                        return [4 /*yield*/, this.refreshGridData()];
                    case 4:
                        _a.sent();
                        this.columnSettingChange();
                        this.updateStorage = true;
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.setHashedUrl = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hashBuffer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.mapcoreProps && this.mapcoreProps.url)) return [3 /*break*/, 2];
                        return [4 /*yield*/, crypto.subtle.digest('SHA-1', new TextEncoder().encode(this.mapcoreProps.url))];
                    case 1:
                        hashBuffer = _a.sent();
                        this.mapcoreProps.hashedUrl = Array.from(new Uint8Array(hashBuffer)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.refreshGridData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.toggleLoading(true);
                        this.rowCount = '';
                        if (!(this.mapcoreProps !== undefined)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.updateLayerInformationIfNeeded()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchDataForAllVisibleColumns()];
                    case 2:
                        _a.sent();
                        this.loadDataIntoGrid();
                        this.populateAggregates();
                        _a.label = 3;
                    case 3:
                        this.toggleLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.selectForCheckBox = function (checkBoxIdentifier, event) {
        switch (checkBoxIdentifier) {
            case 'visibility':
                this.columnSettings.forEach(function (col) { return col.visible = event.target.checked; });
                break;
            case 'sum':
                this.columnSettings.filter(function (col) { return col.isNumeric && col.calculateSum !== null; }).forEach(function (col) { return col.calculateSum = event.target.checked; });
                break;
            case 'average':
                this.columnSettings.filter(function (col) { return col.isNumeric && col.calculateAverage !== null; }).forEach(function (col) { return col.calculateAverage = event.target.checked; });
                break;
            default:
                break;
        }
        this.columnSettingChange();
    };
    DataTableComponent.prototype.setColumnSettingsFilteredForDialog = function () {
        if (this.columnSettingsFilterText.length) {
            var searchText_1 = this.columnSettingsFilterText.toLowerCase();
            this.columnSettingsFilteredForDialog = this.columnSettings.filter(function (x) { return x.name.toLowerCase().indexOf(searchText_1) >= 0 || x.displayName.toLowerCase().indexOf(searchText_1) >= 0; });
        }
        else {
            this.columnSettingsFilteredForDialog = tslib_1.__spread(this.columnSettings);
        }
        this.sortColumns(this.columnSettingsFilteredForDialog);
        this.changeDetectorRef.detectChanges();
    };
    Object.defineProperty(DataTableComponent.prototype, "hasChildTables", {
        get: function () {
            return this.layerChildTables && this.layerChildTables.length > 0; // TODO: We need to know if this individual feature actually has data in any childTables
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "systemLayerId", {
        get: function () {
            var systemLayerId = 0;
            if (this.mapcoreProps) {
                systemLayerId = this.mapcoreProps.id || this.mapcoreProps.idFromSavedLayer || this.mapcoreProps.parentId;
            }
            return systemLayerId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "tableId", {
        get: function () {
            if (this.mapcoreProps && this.mapcoreProps.tables && this.mapcoreProps.tables[0].id) {
                return this.mapcoreProps.tables[0].id;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "columnSettingsStorageKey", {
        get: function () {
            var storageKey;
            if (this.mapcoreProps) {
                var projectIdClause = this.toSqlStringService.getPetlProjectIdClauseIfPresent(this.mapcoreProps.parentId, this.mapcoreProps.query, this.mapcoreProps.isPETL);
                if (projectIdClause) {
                    // use a different storage key for PETL layers
                    storageKey = keys.storage.columnSettingsStorage.replace('{layer_id}', 'petl-' + projectIdClause.value);
                }
                else if (!this.mapcoreProps.isExternal) {
                    storageKey = keys.storage.columnSettingsStorage.replace('{layer_id}', 'table-' + this.tableId.toString());
                }
                else {
                    storageKey = keys.storage.columnSettingsStorage.replace('{layer_id}', 'ex-' + this.mapcoreProps.hashedUrl);
                }
            }
            return storageKey;
        } //**TODO Handle non-mapcore layers**
        ,
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableComponent.prototype, "width", {
        get: function () {
            return window.innerWidth;
        },
        enumerable: true,
        configurable: true
    });
    DataTableComponent.prototype.addCommas = function (value) {
        return (typeof value === 'string' ? parseFloat(value) : value).toLocaleString();
    };
    DataTableComponent.prototype.calculateWidth = function (columnSetting) {
        var displayName = columnSetting.displayName;
        var wideCount = 0;
        var normalCount = 0;
        for (var i = 0; i < displayName.length; i++) {
            var ch = displayName.charAt(i);
            if ((ch >= 'A' && ch <= 'Z' && ch !== 'I') ||
                ch === 'm' ||
                ch === 'w') {
                wideCount++;
            }
            else {
                normalCount++;
            }
        }
        var startingWidth = 50;
        var pixelsPerWideChar = 12;
        var pixelsPerNormalChar = 7;
        return (startingWidth +
            wideCount * pixelsPerWideChar +
            normalCount * pixelsPerNormalChar);
    };
    DataTableComponent.prototype.setColumnCheckboxes = function () {
        this.allVisible = this.columnSettings.every(function (col) { return col.visible; });
        this.allSum = this.columnSettings.filter(function (col) { return col.isNumeric && col.calculateSum !== null; }).every(function (col) { return col.calculateSum; });
        this.allAverage = this.columnSettings.filter(function (col) { return col.isNumeric && col.calculateAverage !== null; }).every(function (col) { return col.calculateAverage; });
    };
    DataTableComponent.prototype.columnSettingChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.toggleLoading(true);
                this.setColumnCheckboxes();
                if (this.columnSettingsTimer) {
                    window.clearTimeout(this.columnSettingsTimer);
                }
                this.columnSettingsTimer = window.setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.columnSettingsTimer = null;
                                return [4 /*yield*/, this.populateGridColumnsFromColumnSettings()];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, this.fetchDataIfNeeded()];
                            case 2:
                                _a.sent();
                                this.loadDataIntoGrid();
                                this.populateAggregates();
                                this.toggleLoading(false);
                                return [2 /*return*/];
                        }
                    });
                }); }, this.delayForFetchingNewColumnData);
                return [2 /*return*/];
            });
        });
    };
    DataTableComponent.prototype.download = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1, _b, rootQuery, filters_1, stringifiedSort, exportParams, query, fieldNames, _loop_1, this_1, fieldNames_1, fieldNames_1_1, fieldName, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        rootQuery = this.layerService.modifyQueryForExport(this.mapcoreProps.parentQuery, this.mapcoreProps.query);
                        if (this.mapcoreProps.state.filters && this.mapcoreProps.state.filters.length > 0) {
                            filters_1 = [];
                            this.mapcoreProps.state.filters.forEach(function (filter) {
                                var filterCopy = tslib_1.__assign({}, filter);
                                if (filter.operator === 'like') {
                                    filterCopy.operator = 'LIKE';
                                }
                                if (_this.columnSettings.filter(function (column) { return column.name.toLowerCase().trim() === filter.field.toLowerCase().trim(); })[0].isNumeric) {
                                    filterCopy.field = "to_char(" + filter.field + ")";
                                }
                                filters_1.push(filterCopy);
                            });
                            (_a = rootQuery.subqueries).push.apply(_a, tslib_1.__spread(filters_1));
                        }
                        stringifiedSort = this.mapcoreProps.state.sort && this.mapcoreProps.state.sort.length > 0
                            ? JSON.stringify(this.mapcoreProps.state.sort)
                            : '';
                        exportParams = {
                            layerId: this.systemLayerId,
                            query: rootQuery,
                            title: this.mapcoreProps.name,
                            sort: stringifiedSort
                        };
                        if (this.selectedObjectIds.length > 0) {
                            query = {
                                field: this.objectIdColumnName,
                                operator: 'IN',
                                value: this.selectedObjectIds.join(',')
                            };
                            rootQuery.subqueries.push(query);
                        }
                        fieldNames = this.tableColumnSettings.filter(function (tableColumSetting) { return tableColumSetting.isVisible; }).map(function (tableColumSetting) { return tableColumSetting.propertyName; });
                        if (this.layerColumns) {
                            // if layerColumns are present, pass those as as parameters, but perserve the order of the columns in fieldNames
                            exportParams.layerColumns = [];
                            _loop_1 = function (fieldName) {
                                var layerColumnsFound = this_1.layerColumns.filter(function (x) { return x.name.toLowerCase().trim() === fieldName.toLowerCase().trim(); });
                                if (layerColumnsFound.length) {
                                    exportParams.layerColumns.push(layerColumnsFound[0]);
                                }
                            };
                            this_1 = this;
                            try {
                                for (fieldNames_1 = tslib_1.__values(fieldNames), fieldNames_1_1 = fieldNames_1.next(); !fieldNames_1_1.done; fieldNames_1_1 = fieldNames_1.next()) {
                                    fieldName = fieldNames_1_1.value;
                                    _loop_1(fieldName);
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (fieldNames_1_1 && !fieldNames_1_1.done && (_b = fieldNames_1.return)) _b.call(fieldNames_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        else {
                            exportParams.fieldNames = fieldNames;
                        }
                        if (this.mapcoreProps.isExternal) {
                            exportParams.data = [];
                            this.filteredData.forEach(function (row) {
                                var dataRow = {};
                                var _loop_2 = function (column) {
                                    if (exportParams.layerColumns.find(function (layerColumn) { return layerColumn.name.toLowerCase().trim() === column.toLowerCase().trim(); })) {
                                        dataRow[column] = row[column];
                                    }
                                };
                                for (var column in row) {
                                    _loop_2(column);
                                }
                                exportParams.data.push(dataRow);
                            });
                            if (exportParams.data.length === 0) {
                                exportParams.data.push({});
                            }
                            else if (exportParams.data.some(function (data) { return data.hasOwnProperty('hasRowDetails'); })) {
                                exportParams.data.forEach(function (data) {
                                    if (data.hasOwnProperty('hasRowDetails')) {
                                        delete data.hasRowDetails;
                                    }
                                });
                            }
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.exportService.exportToExcelAndOpenUrl(exportParams)];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        this.LoggingService.Log('Error exporting data table to excel.', error_1, LogLevel.Error);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.populateLayerInformation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_2, _b, _c, e_3, _d, layers, _loop_3, _e, _f, col, _g, _h, layerColumn, objectIdColumn;
            var _this = this;
            return tslib_1.__generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!this.systemLayerId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.layerApi.getLayerInfo(this.systemLayerId)];
                    case 1:
                        layers = _j.sent();
                        if (layers.length > 0) {
                            if (this.mapcoreProps === undefined) {
                                return [2 /*return*/, []];
                            }
                            this.layerRef = layers[0];
                            this.layerColumns.length = 0;
                            if (!this.mapcoreProps.columns) {
                                (_a = this.layerColumns).push.apply(_a, tslib_1.__spread(layers[0].columns));
                            }
                            else {
                                _loop_3 = function (col) {
                                    //find the related column in layers[0]
                                    var layersCol = layers[0].columns.find(function (x) { return x.databaseColumnOrder === col.databaseColumnOrder; });
                                    if (!layersCol) {
                                        return "continue";
                                    }
                                    //if found, append its listed dataType to mapcoreprops columns list
                                    if (layersCol.databaseDataType) {
                                        col.databaseDataType = layersCol.databaseDataType;
                                    }
                                };
                                try {
                                    //Use this.mapcoreProps.columns with layers[0]'s databaseDataType mapped to each respective column
                                    for (_e = tslib_1.__values(this.mapcoreProps.columns), _f = _e.next(); !_f.done; _f = _e.next()) {
                                        col = _f.value;
                                        _loop_3(col);
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                                (_c = this.layerColumns).push.apply(_c, tslib_1.__spread(this.mapcoreProps.columns));
                            }
                            this.layerColumns.sort(this.columnSortByDBOrder);
                            this.objectIdColumnName = this.layerService.getObjectIdColumnName(this.layerRef);
                            try {
                                for (_g = tslib_1.__values(this.layerColumns), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    layerColumn = _h.value;
                                    layerColumn.name = layerColumn.name.toLowerCase();
                                    if (layerColumn.alias &&
                                        layerColumn.alias.toUpperCase() ===
                                            layerColumn.name.toUpperCase()) {
                                        layerColumn.alias = layerColumn.name.toUpperCase();
                                    }
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_d = _g.return)) _d.call(_g);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                            return [2 /*return*/, this.layerColumns];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        if (this.mapcoreProps.isExternal) {
                            this.layerColumns = tslib_1.__spread(this.mapcoreProps.columns);
                            this.layerColumns.sort(this.columnSortByDBOrder);
                            objectIdColumn = this.layerColumns.find(function (col) { return col.name.toLowerCase().replace('_', '').trim() === _this.idPropertyName; });
                            this.objectIdColumnName = objectIdColumn ? objectIdColumn.name : null;
                            return [2 /*return*/, this.layerColumns];
                        }
                        _j.label = 3;
                    case 3: return [2 /*return*/, []];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchDataForAllVisibleColumns = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fieldNames;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.dataFetched = [];
                        this.selectedObjectIds = [];
                        if (!(!this.tableColumnSettings || !this.tableColumnSettings.length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.populateGridColumnsFromColumnSettings()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        fieldNames = this.tableColumnSettings.map(function (x) { return x.propertyName.toLowerCase().trim(); });
                        if (fieldNames.indexOf(this.objectIdColumnName.toLowerCase().trim()) < 0) {
                            fieldNames.push(this.objectIdColumnName.toLowerCase().trim());
                        }
                        if (this.childTableChildParentKeyColumnNames !== null) {
                            fieldNames = tslib_1.__spread(new Set(fieldNames.concat(this.childTableChildParentKeyColumnNames)));
                        }
                        if (!!this.mapcoreProps.isExternal) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fetchDataForSpecifiedColumns(fieldNames)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.fetchExternalDataForSpecifiedColumns(fieldNames)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchExternalDataForSpecifiedColumns = function (fieldNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchExternalData(fieldNames)];
                    case 1:
                        result = _a.sent();
                        this.dataFetched = result.map(function (row) {
                            var item = {};
                            Object.entries(row).forEach(function (_a) {
                                var _b = tslib_1.__read(_a, 2), col = _b[0], value = _b[1];
                                var colName = col;
                                var builtValue = value;
                                var matchingColumn = _this.layerColumns.find(function (c) { return c.name.toLowerCase().trim() === col.toLowerCase().trim(); });
                                if (matchingColumn && matchingColumn.domainValues) {
                                    colName = matchingColumn.name;
                                    var foundDomainValue = void 0;
                                    if (typeof value === 'number') {
                                        foundDomainValue = matchingColumn.domainValues.find(function (dv) { return parseFloat(dv.codeValue.toString()) === value; });
                                    }
                                    else {
                                        foundDomainValue = matchingColumn.domainValues.find(function (dv) { return dv.codeValue === value; });
                                    }
                                    if (foundDomainValue) {
                                        builtValue = { value: value, domainValue: foundDomainValue.codeValue + " - " + foundDomainValue.shortDescription };
                                    }
                                }
                                item[colName] = builtValue;
                            });
                            return item;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchDataForSpecifiedColumns = function (fieldNames) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4, _a, rootQuery, minRecords, multFactor, adjustment, roundFactor, calculatedAmount, result, dictionary, _loop_4, this_2, dictionary_1, dictionary_1_1, column, columns;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        rootQuery = { operator: 'AND', subqueries: [] };
                        if (this.mapcoreProps.parentQuery) {
                            rootQuery.subqueries.push(this.mapcoreProps.parentQuery);
                        }
                        if (this.mapcoreProps.query) {
                            rootQuery.subqueries.push(this.mapcoreProps.query);
                        }
                        this.defaultRecordsFetched = this.maxRecordsFetched;
                        if (fieldNames.length > 2) {
                            minRecords = 100000;
                            multFactor = 5;
                            adjustment = 4;
                            roundFactor = 1000;
                            calculatedAmount = Math.round((this.defaultRecordsFetched / ((multFactor * Math.sqrt(fieldNames.length)) - adjustment)) / roundFactor) * roundFactor;
                            this.defaultRecordsFetched = Math.max(calculatedAmount, minRecords);
                        }
                        return [4 /*yield*/, this.layerApi.getData(this.systemLayerId, fieldNames, rootQuery, this.defaultRecordsFetched)];
                    case 1:
                        result = _b.sent();
                        if (!(this.mapcoreProps && this.mapcoreProps.columns && !this.mapcoreProps.columns.some(function (c) { return !!c.domainValues; }) && this.mapcoreProps.metaTableId)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.dataDictionaryApi.getColumnsWithDomainValuesByMetaTableId(this.mapcoreProps.metaTableId)];
                    case 2:
                        dictionary = _b.sent();
                        if (dictionary) {
                            _loop_4 = function (column) {
                                var matchingColumn = this_2.mapcoreProps.columns.find(function (c) { return c.name.toLowerCase().trim() === column.columnName.toLowerCase().trim(); });
                                if (matchingColumn) {
                                    matchingColumn.domainValues = column.domainValues;
                                }
                            };
                            this_2 = this;
                            try {
                                for (dictionary_1 = tslib_1.__values(dictionary), dictionary_1_1 = dictionary_1.next(); !dictionary_1_1.done; dictionary_1_1 = dictionary_1.next()) {
                                    column = dictionary_1_1.value;
                                    _loop_4(column);
                                }
                            }
                            catch (e_4_1) { e_4 = { error: e_4_1 }; }
                            finally {
                                try {
                                    if (dictionary_1_1 && !dictionary_1_1.done && (_a = dictionary_1.return)) _a.call(dictionary_1);
                                }
                                finally { if (e_4) throw e_4.error; }
                            }
                        }
                        _b.label = 3;
                    case 3:
                        columns = [];
                        if (this.mapcoreProps && this.mapcoreProps.columns) {
                            columns = fieldNames.map(function (field) { return _this.mapcoreProps.columns.find(function (c) { return c.name.toLowerCase().trim() === field.toLowerCase().trim(); }) || { name: field.toLowerCase().trim() }; });
                        }
                        else {
                            columns = fieldNames.map(function (field) { return ({ name: field.toLowerCase().trim() }); });
                        }
                        this.dataFetched = result.map(function (row) {
                            var item = {};
                            row.forEach(function (value, i) {
                                var builtValue = value;
                                var col = columns[i];
                                if (col.domainValues) {
                                    var foundDomainValue = void 0;
                                    if (typeof value === 'number') {
                                        foundDomainValue = col.domainValues.find(function (dv) { return parseFloat(dv.codeValue.toString()) === value; });
                                    }
                                    else {
                                        foundDomainValue = col.domainValues.find(function (dv) { return dv.codeValue === value; });
                                    }
                                    if (foundDomainValue) {
                                        builtValue = { value: value, domainValue: foundDomainValue.codeValue + " - " + foundDomainValue.shortDescription };
                                    }
                                }
                                item[col.name] = builtValue;
                            });
                            return item;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchDataIfNeeded = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fieldNames, dataKeys_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.dataFetched.length > 0)) return [3 /*break*/, 2];
                        fieldNames = this.tableColumnSettings.map(function (x) { return x.propertyName.toLowerCase().trim(); });
                        dataKeys_1 = Object.keys(this.dataFetched[0]).map(function (x) { return x.toLowerCase().trim(); });
                        if (!fieldNames.some(function (fieldName) { return !dataKeys_1.includes(fieldName); })) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchDataForAllVisibleColumns()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchExternalData = function (outFields) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var formatResponse, featureLayer, results, query, keepRequesting, response;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formatResponse = function (response) {
                            return response.features.map(function (feature) {
                                return Object.keys(feature.attributes).reduce(function (acc, key) {
                                    acc[key.toLowerCase()] = feature.attributes[key];
                                    return acc;
                                }, {});
                            });
                        };
                        featureLayer = this.layerService.mapLayers.feature.find(function (element) { return element.mapcoreProps.guid === _this.mapcoreProps.guid; });
                        results = [];
                        if (!featureLayer) return [3 /*break*/, 3];
                        query = featureLayer.createQuery();
                        query.outFields = outFields;
                        query.num = this.maxRecordsFetched;
                        keepRequesting = true;
                        _a.label = 1;
                    case 1:
                        if (!keepRequesting) return [3 /*break*/, 3];
                        query.start = results.length;
                        return [4 /*yield*/, featureLayer.queryFeatures(query)];
                    case 2:
                        response = _a.sent();
                        if (!results.length) {
                            query.num = response.features.length;
                        }
                        results.push.apply(results, tslib_1.__spread(formatResponse(response)));
                        keepRequesting = response.exceededTransferLimit;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, results];
                }
            });
        });
    };
    DataTableComponent.prototype.fetchLayerChildTables = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, filteredChildTables;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.layerService.getLayerChildTables(this.systemLayerId)];
                    case 1:
                        _a.layerChildTables = _b.sent();
                        filteredChildTables = this.layerChildTables.filter(function (childTable) { return childTable.tableId !== _this.geoSnapTableId; });
                        this.childTableChildParentKeyColumnNames = tslib_1.__spread(new Set(filteredChildTables.map(function (table) { return table.childParentKeyColumnName.toLowerCase().trim(); })));
                        this.childTableChildParentKeyColumnNames.push(this.idPropertyName); // add this in for 161 geosnap
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.updateLayerInformationIfNeeded = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.mapcoreProps.isExternal) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setHashedUrl()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        this.updateStorage = false;
                        _a = this;
                        return [4 /*yield*/, this.populateLayerInformation()];
                    case 3:
                        _a.columnSettings = (_b.sent()).map(function (lc) { return _this.getRefreshedColumnSetting(lc); });
                        this.updateStorage = true;
                        this.refreshColumnSettings();
                        return [4 /*yield*/, this.createOrUpdateFromLocalStorage()];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, this.populateGridColumnsFromColumnSettings()];
                    case 5:
                        _b.sent();
                        this.sortColumns(this.tableColumnSettings);
                        if (!(this.systemLayerId && this.enableAdditionalInformation)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.fetchLayerChildTables()];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.cdkDrop = function (event) {
        this.moveColumn(event.previousIndex, event.currentIndex);
    };
    DataTableComponent.prototype.onFilterEvent = function (event) {
        var _this = this;
        this.mapcoreProps.state.filters = this.filterSettings = event.filterSettings;
        this.filteredData = event.filteredData;
        this.rowCount = this.addCommas(this.filteredData.length);
        this.populateAggregateValues();
        this.changeDetectorRef.detectChanges();
        (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accessingLocalStorage];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'filterSettings', event.filterSettings, 'data-table')];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
    };
    DataTableComponent.prototype.onSortEvent = function (event) {
        var _this = this;
        this.mapcoreProps.state.sort = [];
        this.sortSettings = event.sortSettings;
        event.sortSettings.forEach(function (setting) {
            _this.mapcoreProps.state.sort.push({
                dir: setting.descending ? 'desc' : 'asc',
                field: setting.field
            });
        });
        (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accessingLocalStorage];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'sortSettings', event.sortSettings, 'data-table')];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
    };
    DataTableComponent.prototype.onColumnResize = function (event) {
        var _this = this;
        var column = this.columnSettings.find(function (col) { return col.name.toLowerCase() === event.propertyName.toLowerCase(); });
        if (column) {
            column.width = event.width;
            (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.accessingLocalStorage];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'columnSettings', this.mapColumnsForSave(this.columnSettings), 'data-table')];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    };
    DataTableComponent.prototype.moveItemToTop = function (currentIndex) {
        this.moveColumn(currentIndex, 0);
    };
    DataTableComponent.prototype.moveColumn = function (previousIndex, newIndex) {
        var _this = this;
        var _a;
        if (this.columnSortOrder !== 'custom') {
            this.sortColumns(this.columnSettings);
            this.columnSortOrder = 'custom';
        }
        this.hideCustomSort = false;
        (_a = this.columnSettings).splice.apply(_a, tslib_1.__spread([newIndex, 0], this.columnSettings.splice(previousIndex, 1)));
        (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.accessingLocalStorage];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'enableCustom', !this.hideCustomSort, 'data-table')];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.columnSettingChange()];
                    case 3:
                        _a.sent();
                        this.setColumnSettingsFilteredForDialog();
                        return [2 /*return*/];
                }
            });
        }); })();
    };
    DataTableComponent.prototype.getRefreshedColumnSetting = function (layerColumn, columnSetting) {
        if (columnSetting === void 0) { columnSetting = null; }
        if (!columnSetting) {
            columnSetting = tslib_1.__assign({}, layerColumn);
        }
        columnSetting.visible =
            columnSetting.visible || columnSetting.visible === undefined;
        columnSetting.isNumeric =
            ['FLOAT', 'NUMBER'].indexOf(layerColumn.databaseDataType) >= 0;
        columnSetting.displayName = layerColumn.name.toUpperCase();
        if (layerColumn.alias) {
            columnSetting.name = columnSetting.name.toUpperCase();
            columnSetting.displayName = layerColumn.alias;
        }
        if (!columnSetting.width) {
            columnSetting.width = this.calculateWidth(columnSetting);
        }
        if (layerColumn.databaseColumnOrder) {
            columnSetting.databaseColumnOrder = layerColumn.databaseColumnOrder;
        }
        return columnSetting;
    };
    DataTableComponent.prototype.loadDataIntoGrid = function () {
        var _this = this;
        if (this.mapcoreProps) {
            var dataForGrid = this.dataFetched;
            if (this.showSelected) {
                dataForGrid = dataForGrid.filter(function (x) { return _this.selectedObjectIds.indexOf(x[_this.objectIdColumnName]) >= 0; });
            }
            this.detectUrls(dataForGrid);
            var hasRowDetails_1 = this.hasChildTables;
            dataForGrid.forEach(function (row) {
                var e_5, _a;
                try {
                    for (var _b = tslib_1.__values(Object.keys(row)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var field = _c.value;
                        if (row[field] != null && row[field].domainValue) {
                            row[field] = row[field].domainValue;
                        }
                        if (field === 'has_geometry' && row[field] === 'N') {
                            row.rowClass = RowClass.HighlightRed;
                        }
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
                row.hasRowDetails = hasRowDetails_1;
            });
            this.fullData = this.filteredData = dataForGrid;
            this.gridDataResult = tslib_1.__spread(dataForGrid);
            this.rowCount = this.addCommas(dataForGrid.length);
        }
    };
    /**
     * Modifies the data passed in to add isUrl boolean if a url is detected for a column
     * @param dataForGrid Array of data rows
     */
    DataTableComponent.prototype.detectUrls = function (dataForGrid) {
        var e_6, _a, e_7, _b;
        if (dataForGrid && dataForGrid.length) {
            // Find the url column first
            var urlColumns = [];
            var nonurlColumns = [];
            var columnLength = Object.keys(dataForGrid[0]).length;
            try {
                for (var dataForGrid_1 = tslib_1.__values(dataForGrid), dataForGrid_1_1 = dataForGrid_1.next(); !dataForGrid_1_1.done; dataForGrid_1_1 = dataForGrid_1.next()) {
                    var row = dataForGrid_1_1.value;
                    var _loop_5 = function (col) {
                        // Iterate over every column in the row
                        if (!nonurlColumns.includes(col) &&
                            !urlColumns.includes(col)) {
                            // Only check columns that we don't know about yet
                            var value = row[col];
                            if (value !== null) {
                                // Only check if not null, as the url column could be nullable
                                var columnSetting = this_3.columnSettings.find(function (cs) { return cs.name === col; });
                                if (columnSetting && (columnSetting.isUrl || this_3.isUrl(value))) {
                                    urlColumns.push(col);
                                }
                                else {
                                    nonurlColumns.push(col);
                                }
                            }
                        }
                    };
                    var this_3 = this;
                    // Iterate over every row of data
                    for (var col in row) {
                        _loop_5(col);
                    }
                    if (columnLength === urlColumns.length + nonurlColumns.length) {
                        break;
                    } // If all columns have been checked, stop checking completly
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (dataForGrid_1_1 && !dataForGrid_1_1.done && (_a = dataForGrid_1.return)) _a.call(dataForGrid_1);
                }
                finally { if (e_6) throw e_6.error; }
            }
            if (urlColumns.length) {
                try {
                    for (var _c = tslib_1.__values(this.columnSettings), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var columnSetting = _d.value;
                        if (urlColumns.includes(columnSetting.name)) {
                            columnSetting.isUrl = true;
                        }
                        else {
                            columnSetting.isUrl = false;
                        }
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            }
        }
    };
    DataTableComponent.prototype.isUrl = function (value) {
        return (value &&
            typeof value === 'string' &&
            /^http[s]?:\/\/(?:[a-zA-Z]|[0-9]|[$-_@.&+]|[!*(), ]|(?:%[0-9a-fA-F][0-9a-fA-F]))+$/.test(value.trim()));
    };
    DataTableComponent.prototype.mapSelectedFeatures = function () {
        var _this = this;
        if (this.selectedObjectIds.length > 0) {
            var query = {
                field: this.objectIdColumnName,
                operator: 'IN',
                value: this.selectedObjectIds.join(',')
            };
            if (!this.mapcoreProps.isExternal) {
                var layerSettings = {
                    id: this.systemLayerId,
                    query: query,
                    zoomToLayer: true
                };
                this.layerService.addMapcoreLayersToMap([layerSettings]);
            }
            else {
                var featureLayer = this.layerService.mapLayers.feature.find(function (element) { return element.mapcoreProps.guid === _this.mapcoreProps.guid; });
                this.layerService.addExternalLayersToMap({
                    url: this.mapcoreProps.url,
                    name: featureLayer.title,
                    visible: true,
                    zoomToLayer: true
                }, tslib_1.__assign({}, this.mapcoreProps, { query: query }));
            }
            if (this.lassoTool) {
                this.lassoTool.clearFeatureResults();
            }
        }
    };
    DataTableComponent.prototype.populateGridColumnsFromColumnSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_8, _a, settingsStorage, visibleColumnSettings, idColumn, _b, _c, columnSetting, gridColumn, geometryColumn_1, geometryColumnSetting;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(this.mapcoreProps !== undefined)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.accessingLocalStorage];
                    case 1:
                        _d.sent();
                        return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                    case 2:
                        settingsStorage = _d.sent();
                        if (!this.updateStorage) return [3 /*break*/, 7];
                        if (!(!settingsStorage || settingsStorage.columnSettings.length === 0)) return [3 /*break*/, 4];
                        //first time
                        this.hideCustomSort = true;
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'columnSettings', this.mapColumnsForSave(this.columnSettings), 'data-table')];
                    case 3:
                        _d.sent();
                        return [3 /*break*/, 7];
                    case 4:
                        if (!(JSON.stringify(settingsStorage.columnSettings) !== JSON.stringify(this._columnSettings))) return [3 /*break*/, 6];
                        //consecutive times
                        if (settingsStorage.sortBy) {
                            this.columnSortOrder = settingsStorage.sortBy;
                            if (settingsStorage.sortBy === 'custom') {
                                this.hideCustomSort = false;
                            }
                        }
                        return [4 /*yield*/, this.localStorageService.setPropertyOfObject(this.columnSettingsStorageKey, [], 'columnSettings', this.mapColumnsForSave(this.columnSettings), 'data-table')];
                    case 5:
                        _d.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        if (settingsStorage.sortBy) {
                            this.columnSortOrder = settingsStorage.sortBy;
                        }
                        _d.label = 7;
                    case 7:
                        this.tableColumnSettings = [];
                        visibleColumnSettings = this.columnSettings.filter(function (x) { return x.visible; });
                        if (visibleColumnSettings.length === 0) {
                            idColumn = tslib_1.__assign({}, this.columnSettings.find(function (c) { return c.name.toLowerCase().trim() === _this.idPropertyName; }));
                            idColumn.name = idColumn.name.toLowerCase();
                            idColumn.visible = true;
                            this.addColumnSettingToTable(idColumn);
                        }
                        else {
                            try {
                                for (_b = tslib_1.__values(this.columnSettings), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    columnSetting = _c.value;
                                    gridColumn = tslib_1.__assign({}, columnSetting);
                                    gridColumn.name = gridColumn.name.toLowerCase().trim();
                                    this.addColumnSettingToTable(gridColumn);
                                }
                            }
                            catch (e_8_1) { e_8 = { error: e_8_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_8) throw e_8.error; }
                            }
                            geometryColumn_1 = this.columnSettings.find(function (c) { return c.name.toLowerCase().trim() === 'has_geometry'; });
                            if (geometryColumn_1 && !this.tableColumnSettings.find(function (c) { return c.propertyName.toLowerCase().trim() === geometryColumn_1.name.toLowerCase().trim(); })) {
                                geometryColumnSetting = tslib_1.__assign({}, geometryColumn_1);
                                geometryColumnSetting.visible = false;
                                this.addColumnSettingToTable(geometryColumnSetting);
                            }
                            this.sortColumns(this.tableColumnSettings);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableComponent.prototype.addColumnSettingToTable = function (columnSetting) {
        var columnDataType = 'string';
        if (columnSetting.databaseDataType === 'DATE') {
            columnDataType = 'date';
        }
        else if (columnSetting.isUrl) {
            columnDataType = 'url';
        }
        var tableColumnSetting = {
            canFilter: true,
            canSort: true,
            columnOrder: columnSetting.databaseColumnOrder,
            dataFilter: columnSetting.databaseDataType === 'DATE' ? 'short' : '',
            dataType: columnDataType,
            footerText: '',
            isVisible: columnSetting.visible,
            propertyName: columnSetting.name,
            title: columnSetting.displayName,
            width: columnSetting.width ? columnSetting.width + "px" : ''
        };
        var filter = this.filterSettings.find(function (filterSetting) { return filterSetting.field === columnSetting.name; });
        if (filter) {
            tableColumnSetting.filter = filter.value;
        }
        this.tableColumnSettings.push(tableColumnSetting);
    };
    DataTableComponent.prototype.populateValidColumnSettings = function () {
        var _loop_6 = function (i) {
            var columnSetting = this_4.columnSettings[i];
            var foundLayerColumns = this_4.layerColumns.filter(function (x) { return x.name.toLowerCase() === columnSetting.name.toLowerCase(); });
            if (foundLayerColumns.length > 0) {
                var layerColumn = foundLayerColumns[0];
                columnSetting = this_4.getRefreshedColumnSetting(layerColumn, columnSetting);
            }
            else {
                this_4.columnSettings.splice(i, 1);
                i--;
            }
            out_i_1 = i;
        };
        var this_4 = this, out_i_1;
        for (var i = 0; i < this.columnSettings.length; i++) {
            _loop_6(i);
            i = out_i_1;
        }
    };
    DataTableComponent.prototype.populateColumnSettingsToMax = function () {
        var e_9, _a;
        var visibleColumnSettings = this.columnSettings.filter(function (x) { return x.visible; })
            .length;
        var _loop_7 = function (layerColumn) {
            if (this_5.columnSettings.filter(function (x) {
                return x.name.toLowerCase() === layerColumn.name.toLowerCase();
            }).length === 0) {
                var columnSetting = this_5.getRefreshedColumnSetting(layerColumn);
                if (visibleColumnSettings <= this_5.maxDefaultColumns) {
                    visibleColumnSettings++;
                }
                else {
                    columnSetting.visible = false;
                }
                this_5.columnSettings.push(columnSetting);
            }
        };
        var this_5 = this;
        try {
            for (var _b = tslib_1.__values(this.layerColumns), _c = _b.next(); !_c.done; _c = _b.next()) {
                var layerColumn = _c.value;
                _loop_7(layerColumn);
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_9) throw e_9.error; }
        }
    };
    DataTableComponent.prototype.populateAggregates = function () {
        this.setAggregateArray();
        this.populateAggregateValues();
    };
    DataTableComponent.prototype.populateAggregateValues = function () {
        var _this = this;
        var fractionDigits = 4;
        if (this.aggregates && this.aggregates.length) {
            this.aggregates = this.getAggregateData(this.filteredData, this.aggregates);
            this.aggregates.forEach(function (aggregateField) {
                var tableColumn = _this.tableColumnSettings.find(function (c) { return c.propertyName.toLowerCase().trim() === aggregateField.field.toLowerCase().trim(); });
                if (tableColumn) {
                    var footerText_1 = [];
                    tableColumn.footerText = '';
                    aggregateField.aggregates.forEach(function (aggregate) {
                        if (aggregate.type === 'average') {
                            var averageText = aggregate.value.toFixed(fractionDigits);
                            tableColumn.footerText += 'Avg: ' + _this.addCommas(averageText);
                            footerText_1.push("Avg: " + _this.addCommas(averageText));
                        }
                        if (aggregate.type === 'sum') {
                            if (Math.floor(aggregate.value) === aggregate.value) {
                                footerText_1.push("Sum: " + _this.addCommas(aggregate.value));
                            }
                            else {
                                footerText_1.push("Sum: " + _this.addCommas(aggregate.value.toFixed(fractionDigits)));
                            }
                        }
                    });
                    tableColumn.footerText = footerText_1.join(' ');
                }
            });
            this.changeDetectorRef.detectChanges();
        }
    };
    DataTableComponent.prototype.getAggregateData = function (data, aggregates) {
        aggregates.forEach(function (aggregateField) {
            var aggregateFieldData = data.map(function (row) { return row[aggregateField.field]; });
            var sum = aggregateFieldData.reduce(function (a, b) { return Number(a) + Number(b); }, 0);
            aggregateField.aggregates.forEach(function (aggregate) {
                if (aggregate.type === 'average') {
                    aggregate.value = aggregateFieldData.length === 0 ? 0 : sum / aggregateFieldData.length;
                }
                if (aggregate.type === 'sum') {
                    aggregate.value = sum;
                }
            });
        });
        return aggregates;
    };
    DataTableComponent.prototype.refreshColumnSettings = function () {
        this.populateValidColumnSettings();
        this.populateColumnSettingsToMax();
    };
    DataTableComponent.prototype.setAggregateArray = function () {
        var e_10, _a;
        this.aggregates = [];
        try {
            for (var _b = tslib_1.__values(this.columnSettings), _c = _b.next(); !_c.done; _c = _b.next()) {
                var columnSetting = _c.value;
                if (columnSetting.calculateSum || columnSetting.calculateAverage) {
                    var aggregateField = {
                        aggregates: [],
                        field: columnSetting.name.toLowerCase()
                    };
                    if (columnSetting.calculateSum) {
                        aggregateField.aggregates.push({
                            type: 'sum',
                            value: 0
                        });
                    }
                    if (columnSetting.calculateAverage) {
                        aggregateField.aggregates.push({
                            type: 'average',
                            value: 0
                        });
                    }
                    this.aggregates.push(aggregateField);
                }
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_10) throw e_10.error; }
        }
        this.showFooter = this.aggregates.length > 0;
    };
    DataTableComponent.prototype.changeCurMultiTab = function () {
        var _this = this;
        //find the the mapcorePropsIndex that has the selected layerId
        var i = this._mapcoreProps.findIndex(function (x) { return _this.curMultiTab === x.esriLayerId; });
        if (i > -1) {
            this.mapcoreProps = this._mapcoreProps[i];
        }
        if (this.lassoTool) {
            this.lassoTool.deactivate();
            this.lassoTool.clearFeatureResults();
        }
    };
    DataTableComponent.prototype.closeColumnSettings = function (event) {
        if (!event.detail) {
            this.toggleColumnSettings();
        }
    };
    DataTableComponent.prototype.toggleColumnSettings = function () {
        this.columnSettingsDialogOpened = !this.columnSettingsDialogOpened;
        this.changeDetectorRef.detectChanges();
    };
    DataTableComponent.prototype.toggleColumnVisibility = function (columnSetting) {
        columnSetting.visible = !columnSetting.visible;
        this.columnSettingChange();
    };
    DataTableComponent.prototype.toggleShowSelected = function () {
        this.showSelected = !this.showSelected;
        this.loadDataIntoGrid();
        this.populateAggregates();
    };
    DataTableComponent.prototype.toggleSortColumnSettings = function (sortField) {
        if (this.columnSettingsSortField === sortField) {
            this.columnSettingsSortDescending = !this.columnSettingsSortDescending;
        }
        else {
            this.columnSettingsSortDescending = false;
        }
        this.columnSettingsSortField = sortField;
    };
    DataTableComponent.prototype.createOrUpdateFromLocalStorage = function (skip) {
        if (skip === void 0) { skip = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.accessingLocalStorage = (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var hasKey, settingsStorage, columnStorageSettings;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.localStorageService.hasKey(this.columnSettingsStorageKey)];
                                    case 1:
                                        hasKey = _a.sent();
                                        if (!hasKey) return [3 /*break*/, 3];
                                        return [4 /*yield*/, this.localStorageService.get(this.columnSettingsStorageKey)];
                                    case 2:
                                        settingsStorage = _a.sent();
                                        if (skip === 'columnSettings') {
                                            this._columnSettings = this.mapColumnsFromSaved(this.columnSettings, settingsStorage && settingsStorage.columnSettings ? settingsStorage.columnSettings : []);
                                        }
                                        else {
                                            this.columnSettings = this.mapColumnsFromSaved(this.columnSettings, settingsStorage && settingsStorage.columnSettings ? settingsStorage.columnSettings : []);
                                        }
                                        if (skip === 'order') {
                                            this._columnSortOrder = settingsStorage && settingsStorage.sortBy ? settingsStorage.sortBy : 'database';
                                        }
                                        else {
                                            this.columnSortOrder = settingsStorage && settingsStorage.sortBy ? settingsStorage.sortBy : 'database';
                                        }
                                        if (settingsStorage) {
                                            if (settingsStorage.enableCustom) {
                                                this.hideCustomSort = false;
                                            }
                                            if (settingsStorage.filterSettings) {
                                                this.filterSettings = settingsStorage.filterSettings;
                                            }
                                            if (settingsStorage.sortSettings) {
                                                this.sortSettings = settingsStorage.sortSettings;
                                            }
                                        }
                                        this.columnSettings.forEach(function (columnSetting) {
                                            var tableColumnSetting = _this.tableColumnSettings.find(function (tableColumn) { return tableColumn.propertyName.toLowerCase() === columnSetting.name.toLowerCase(); });
                                            if (tableColumnSetting) {
                                                if (columnSetting.width) {
                                                    tableColumnSetting.width = columnSetting.width + "px";
                                                }
                                                var tableFilterSetting = _this.filterSettings.find(function (filterSetting) { return filterSetting.field.toLowerCase() === columnSetting.name.toLowerCase(); });
                                                if (tableFilterSetting) {
                                                    tableColumnSetting.filter = tableFilterSetting.value;
                                                }
                                            }
                                        });
                                        return [3 /*break*/, 5];
                                    case 3:
                                        columnStorageSettings = {
                                            columnSettings: this.mapColumnsForSave(this.columnSettings),
                                            enableCustom: !this.hideCustomSort,
                                            filterSettings: this.filterSettings,
                                            showAll: false,
                                            sortBy: this.columnSortOrder,
                                            sortSettings: this.sortSettings
                                        };
                                        if (!(this.systemLayerId > 0)) return [3 /*break*/, 5];
                                        return [4 /*yield*/, this.localStorageService.set(this.columnSettingsStorageKey, columnStorageSettings, 'data-table')];
                                    case 4:
                                        _a.sent();
                                        _a.label = 5;
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); })();
                        return [4 /*yield*/, this.accessingLocalStorage];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DataTableComponent.prototype.toggleCloseOptions = function () {
        this.showCloseOptions = !this.showCloseOptions;
    };
    DataTableComponent.prototype.onRowSelection = function (event) {
        if (this.lassoTool) {
            this.lassoTool.clearFeatureResults();
        }
        this.selectedObjectIds = event.selectedRowIds;
    };
    DataTableComponent.prototype.selectFromMap = function () {
        var _this = this;
        this.lassoTool.deactivate();
        this.lassoTool.containerElement = this.hostElement;
        var subs = [];
        subs.push(this.lassoTool.oncomplete.subscribe(function () {
            var featureresults = _this.lassoTool.layerFeatureResults.map(function (r) { return r.featureResults; }).flat();
            if (featureresults.length) {
                var frObjectIdKey_1 = Object.keys(featureresults[0].attributes).find(function (key) { return key.toLowerCase() === _this.idPropertyName; });
                if (frObjectIdKey_1) {
                    var selectedIds = featureresults.map(function (result) { return result.attributes[frObjectIdKey_1]; });
                    _this.selectedObjectIds = tslib_1.__spread(new Set(selectedIds));
                }
            }
            if (_this.dataFetched.length) {
                var objectIdKey_1 = Object.keys(_this.dataFetched[0]).find(function (k) { return k.toLowerCase() === _this.idPropertyName; });
                if (objectIdKey_1) {
                    _this.selectedObjectIds = _this.selectedObjectIds.filter(function (id) { return !!_this.dataFetched.find(function (d) { return d[objectIdKey_1] === id; }); });
                }
            }
            _this.lassoTool.deactivate();
            subs.forEach(function (sub) { return sub.unsubscribe(); });
            _this.toggleLoading(false);
        }));
        subs.push(this.lassoTool.drawEnd.subscribe(function () {
            _this.selectedObjectIds = [];
            _this.ondrawcomplete.emit();
            _this.toggleLoading(true);
        }));
        this.lassoTool.spatialQueryType = 'feature';
        this.lassoTool.runSpatialQueryOnSketchComplete = true;
        this.lassoTool.reactivateSketchOnSketchComplete = false;
        this.lassoTool.displayFeatureGraphicsAfterSpatialQuery = true;
        this.lassoTool.sketchDefaultCreateOptions = { mode: 'freehand' };
        this.lassoTool.mapView = this.mapView;
        this.lassoTool.esriLayers = [this.layerService.getExistingEsriLayerById(this.mapcoreProps.esriLayerId)];
        this.lassoTool.clearFeatureResults();
        this.lassoTool.activate();
        this.ondraw.emit();
    };
    DataTableComponent.prototype.triggerOpenEditor = function (asEdit) {
        if (asEdit === void 0) { asEdit = false; }
        var objectId = asEdit ? this.selectedObjectIds[0] : null;
        this.openEditor.emit({ layerId: this.mapcoreProps.esriLayerId, objectId: objectId });
    };
    DataTableComponent.prototype.mapColumnsForSave = function (columnSettings) {
        return columnSettings.map(function (column) { return ({
            name: column.name,
            visible: column.visible,
            width: column.width,
            displayName: column.displayName,
            databaseDataType: column.databaseDataType,
            databaseColumnOrder: column.databaseColumnOrder,
            columnIdentifierId: column.columnIdentifierId,
            isNumeric: column.isNumeric,
            calculateAverage: column.calculateAverage,
            calculateSum: column.calculateSum
        }); });
    };
    DataTableComponent.prototype.mapColumnsFromSaved = function (columnSettings, fromSaved) {
        columnSettings.forEach(function (column) {
            var match = fromSaved.find(function (x) { return x.name === column.name; });
            if (match) {
                column.visible = match.visible;
                column.width = match.width;
                column.calculateAverage = match.calculateAverage;
                column.calculateSum = match.calculateSum;
            }
        });
        return columnSettings.sort(function (a, b) {
            var aIndex = fromSaved.findIndex(function (x) { return x.name === a.name; });
            var bIndex = fromSaved.findIndex(function (x) { return x.name === b.name; });
            return aIndex - bIndex;
        });
    };
    DataTableComponent.prototype.isDataItem = function (value) {
        return value !== null && typeof value === 'object';
    };
    DataTableComponent.prototype.toggleLoading = function (isLoading) {
        this.loading = isLoading;
        this.changeDetectorRef.detectChanges();
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [Boolean])
    ], DataTableComponent.prototype, "opened", null);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], DataTableComponent.prototype, "columnSettingsDialogOpened", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "delayForFetchingNewColumnData", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "pageSize", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], DataTableComponent.prototype, "recordEditorEnabled", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "maxDefaultColumns", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "maxRecordsFetched", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], DataTableComponent.prototype, "defaultRecordsFetched", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], DataTableComponent.prototype, "enableAdditionalInformation", void 0);
    return DataTableComponent;
}(BaseComponent));
export { DataTableComponent };
